import React from 'react';
import {Link} from 'react-router-dom';
import {Sparkles} from 'lucide-react';

/**
 * Small "join to save" nudge shown to non-members in the cart when at
 * least one line has a My Labs Plus member price. Renders nothing when
 * there is no computable cart savings, it keeps the JOIN affordance but
 * omits the percentage claim.
 */
const MembershipNudge: React.FC<{savingsPct: number; className?: string}> = ({savingsPct, className}) => {
    return (
        <Link
            to="/membership/benefits"
            className={`inline-flex items-center gap-1.5 text-xs font-medium text-mld-primary hover:underline ${className ?? ''}`}>
            <Sparkles className="h-3.5 w-3.5" />
            {savingsPct > 0 ? `Join My Labs+ to save ${savingsPct}%` : 'Join My Labs+'}
        </Link>
    );
};

export default MembershipNudge;
